import '../App.css';

import { useEffect, useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import FilterControls from '../components/FilterControls';
import FoodDetailModal from '../components/FoodDetailModal';
import Header from '../components/Header';
import MenuItemCard from '../components/MenuItemCard';
import ProcessingModal from '../components/ProcessingModal';
import StickyFilters from '../components/StickyFilters';
import UploadSection from '../components/UploadSection';

// Sample demo data for logged-out users
const DEMO_MENU_ITEMS = [
  {
    menuResponse:
      'NACHOS, LOS QUE NO SON TAN MEXICANOS PERO TODO MUNDO CREE QUE SÍ. TOTOPOS CON QUESO GRATINADO, GUACAMOLE, PICO DE GALLO, CREMA AGRIA Y JALAPEÑO.',
    menuSearchQuery: 'Nachos',
    nutritional_score: 3,
    description: 'Crispy tortilla chips topped with melted cheese, guacamole, pico de gallo, sour cream and jalapeños.',
    approximate_calories: 600,
    price: 12.5,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'http://media2.s-nbcnews.com/i/streams/2014/November/141105/1D274907154303-today-nachos-141105.jpg',
      'https://www.sogoodblog.com/wp-content/uploads/2014/02/super-nachos-recipe.jpg',
      'https://foodiewish.com/wp-content/uploads/2021/12/vegetarian-nachos-with-guacamole-86796-1-scaled.jpeg',
    ],
  },
  {
    menuResponse:
      'La insuperable Cochinita Pibil. CERDO MARINADO 48 HORAS EN NUESTRO ADOBO ESTRELLA, HORNEADO EN HOJA DE PLÁTANO DURANTE 12 HORAS A BAJA TEMPERATURA, SERVIDO DESHEBRADO SOBRE TORTILLA DE MAÍZ, ACOMPAÑADO DE CEBOLLA MORADA ENCURTIDA.',
    menuSearchQuery: 'Cochinita Pibil',
    nutritional_score: 4,
    approximate_calories: 700,
    price: 18.95,
    nutritional_summary: 'Rich in protein and fats, moderate carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'https://www.allrecipes.com/thmb/TnQ8XgFbZMlRjcPh04ixTdshOFE=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/4919182-8d9d75b698ee4dae93b0b5ecbb639441.jpg',
      'https://d36tnp772eyphs.cloudfront.net/blogs/1/2019/04/Cochinita-pibil.jpg',
      'https://www.funsunmexico.com/blog/wp-content/uploads/Cochinita-Pibil.jpg',
    ],
  },
  {
    menuResponse:
      'Tacos de Pollo al Pibil. LA OPCIÓN LIGERA DE LA COCHINITA ELABORADO CON POLLO. SERVIDO DESHEBRADO SOBRE TORTILLA DE MAÍZ ACOMPAÑADO DE CEBOLLA MORADA ENCURTIDA.',
    menuSearchQuery: 'Tacos de Pollo al Pibil',
    nutritional_score: 5,
    approximate_calories: 500,
    price: 14.75,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    // Allergen information
    cereals_containing_gluten: 'low',
    crustaceans: 'low',
    eggs: 'low',
    fish: 'low',
    peanuts: 'low',
    soybeans: 'low',
    milk: 'low',
    nuts: 'low',
    celery: 'low',
    mustard: 'low',
    sesame_seeds: 'low',
    sulphur_dioxide_and_sulphites: 'high',
    lupin: 'low',
    molluscs: 'low',
    imageUrls: [
      'https://www.muydelish.com/wp-content/uploads/2021/04/Cochinita-pibil.jpg',
      'https://inmamamaggieskitchen.com/wp-content/uploads/2019/07/Pollo-Pibil-Taco.jpg',
      'https://inmamamaggieskitchen.com/wp-content/uploads/2019/07/Pollo-Pibil-.jpg',
    ],
  },
  {
    menuResponse:
      'Flautas de patata e pollo. TACOS FRITOS RELLENOS. ACOMPAÑADOS DE GUACAMOLE, CREMA AGRIA, LECHUGA Y QUESO FRESCO. ELIGE EL RELLENO DE POLLO O VEGETARIANO DE PATATA.',
    menuSearchQuery: 'Flautas de patata e pollo',
    nutritional_score: 2,
    approximate_calories: 650,
    price: 16.25,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: null,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.theanthonykitchen.com/wp-content/uploads/2019/06/Chicken-Flautas-1.jpg',
      'https://sabrosano.com/wp-content/uploads/2023/04/Flautas-de-Pollo-con-Papa-Foto-Cuadrada.jpg',
      'https://milrecetas.net/wp-content/uploads/2017/09/Flautas-de-pollo-2.jpg',
    ],
  },
  {
    menuResponse: 'Taco del Mar estilo Baja. TORTILLA DE MAÍZ, MERLUZA REBOZADA, PICO DE GALLO Y MAYONESA DE CHIPOTLE.',
    menuSearchQuery: 'Taco del Mar estilo Baja',
    nutritional_score: 4,
    approximate_calories: 450,
    price: 9.95,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://cdn7.kiwilimon.com/recetaimagen/36709/45770.jpg',
      'https://mysliceofmexico.files.wordpress.com/2020/03/000-fish-tacos-baja-style-my-slice-of-mexico.jpg',
      'https://tacodelmar.com/wp-content/uploads/2021/02/Fish-Tacos_2-small.png',
    ],
  },
  {
    menuResponse:
      'Quesadillas/Sincronizadas. TORTILLA DE TRIGO (O MAÍZ) RELLENAS DE JAMÓN Y QUESO. ACOMPAÑADAS DE PICO DE GALLO.',
    menuSearchQuery: 'Quesadillas',
    nutritional_score: 3,
    approximate_calories: 550,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'low',
    protein: 'medium',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://cdn.momsdish.com/wp-content/uploads/2021/04/Chicken-Quesadillas012-2048x3072.jpg',
      'https://valentinascorner.com/wp-content/uploads/2021/04/Cheese-Quesadilla-1-760x1140.jpg',
      'https://1.bp.blogspot.com/-zzZRc0G5Q5g/VQ1z3hUiVII/AAAAAAAABJY/srJ_yo3Lk9Y/s1600/IMG_3378.JPG',
    ],
  },
  {
    menuResponse:
      'Taco Poblano. DELICIOSO GUISADO DE RAJAS POBLANAS (PIMIENTO VERDE), CEBOLLITA Y MAÍZ DULCE. EN TORTILLA DE MAÍZ Y ACOMPAÑADOS DE GUACAMOLE.',
    menuSearchQuery: 'Taco Poblano',
    nutritional_score: 5,
    approximate_calories: 400,
    nutritional_summary: 'Moderate in carbohydrates and fats, low protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://1.bp.blogspot.com/-idNHct8BA2c/V-GDEAyDzjI/AAAAAAAAKiA/5XpFWBqma9gJ5AcHJnveJFQEBo5Xzr82QCLcB/s1600/rajas%2Bcon%2Bqueso%2B3A.jpg',
      'https://i.pinimg.com/originals/29/85/9d/29859dda865ec4c7879fca6c3b72da94.jpg',
      'https://media.blueapron.com/recipes/2922/square_newsletter_images/1523483874-1-0009-0337/0514_2PV2_Tacos_5555_WEB_SQ_hi_res.jpg',
    ],
  },
  {
    menuResponse: 'Tostada de atún. TORTILLA DE MAÍZ CRUJIENTE, CAMA DE GUACAMOLE, ATÚN Y SÉSAMO.',
    menuSearchQuery: 'Tostada de atún',
    nutritional_score: 5,
    approximate_calories: 350,
    nutritional_summary: 'High in protein, moderate fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'medium',
    protein: 'high',
    purines: 'high',
    oxalates: null,
    potassium: 'high',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://cdn0.recetasgratis.net/es/posts/4/9/4/tostadas_de_atun_mexicanas_75494_orig.jpg',
      'https://www.elcomal.com/wp-content/uploads/2022/08/Salpicon-Tostadas-1-2000x1335.jpg',
      'https://i.pinimg.com/originals/38/f4/57/38f45761fbd4d89925f6d2f6ef641e55.jpg',
    ],
  },
  {
    menuResponse:
      'La Birrita de la Güerita. TERNERA GUISADA EN ADOBO DE CHILES, SERVIDA EN TACOS O QUESADILLAS ACOMPAÑADA DE CONSOME, CEBOLLA Y CILANTRO.',
    menuSearchQuery: 'La Birrita de la Güerita',
    nutritional_score: 5,
    approximate_calories: 600,
    nutritional_summary: 'High in protein and fats, moderate carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'medium',
    cholesterol: 'high',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'low',
    protein: 'high',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://mir-s3-cdn-cf.behance.net/project_modules/fs/cfb6b7115319533.604bde7be5351.jpg',
      'https://img.restaurantguru.com/cecf-Restaurant-Birria-De-Res-Estilo-Sinaloa-La-Guerita-food.jpg',
      'https://i.pinimg.com/originals/40/b4/af/40b4afa5e1af6d0f53e5ea12b687b89b.png',
    ],
  },
  {
    menuResponse:
      'Tacos al Pastor. AUTÉNTICO TACO DE CERDO ADOBADO, CORTADO DIRECTAMENTE DEL TROMPO, SOBRE TORTILLA DE MAÍZ, ACOMPAÑADO DE PIÑA, CILANTRO Y CEBOLLA.',
    menuSearchQuery: 'Tacos al Pastor',
    nutritional_score: 5,
    approximate_calories: 500,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'low',
    imageUrls: [
      'https://www.jocooks.com/wp-content/uploads/2022/04/tacos-al-pastor-feature-1.jpg',
      'http://milrecetas.net/wp-content/uploads/2016/09/Tacos-al-pastor-3.jpg',
      'https://www.culinaryhill.com/wp-content/uploads/2022/12/Tacos-al-Pastor-Culinary-Hill-1200x800-1.jpg',
    ],
  },
  {
    menuResponse: 'Gringa al Pastor. DOS TORTILLAS DE TRIGO RELLENAS DE CARNE AL PASTOR Y QUESO FUNDIDO.',
    menuSearchQuery: 'Gringa al Pastor',
    nutritional_score: 4,
    approximate_calories: 650,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'low',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://productoschata.com/wp-content/uploads/elementor/thumbs/Gringa-Pastor_H1-q7vbnz0ehweut9hmqzqbrl5jrolruukrhmgh1u9g8g.jpg',
      'https://www.gastrolabweb.com/u/fotografias/m/2021/5/15/f1280x720-13288_144963_5050.jpeg',
      'https://www.cocinavital.mx/wp-content/uploads/2017/09/gringa-al-pastor115.jpg',
    ],
  },
  {
    menuResponse: 'Torta al Pastor. BOCADILLO DE CARNE AL PASTOR, CON FRIJOLES, QUESO, CILANTRO, CEBOLLA Y PIÑA.',
    menuSearchQuery: 'Torta al Pastor',
    nutritional_score: 4,
    approximate_calories: 700,
    nutritional_summary: 'High in carbohydrates and fats, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://storage.googleapis.com/dam-bks-prd-1385851.bks.prd.v8.commerce.mi9cloud.com/Images/Recipes/Grilled-Torta-al-Pastor-600x360.webp',
      'https://www.sargento.com/assets/Uploads/Recipe/Image/torta-v2__FillWzExNzAsNTgzXQ.jpg',
      'https://thumbs.dreamstime.com/z/mexican-food-pork-sandwich-also-known-as-torta-al-pastor-mexican-food-pork-sandwich-also-known-as-torta-al-pastor-wooden-185828030.jpg',
    ],
  },
  {
    menuResponse:
      'El tace Moreno de Pastor. TACO DE PASTOR CON TORTILLA DE MAÍZ EN UNA CAMA DE QUESO Y FRIJOLES CON CEBOLLA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'El tace Moreno de Pastor',
    nutritional_score: 5,
    approximate_calories: 550,
    nutritional_summary: 'Moderate in protein and fats, low carbohydrates.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: true,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'low',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/08/4.jpg',
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/08/6-1000x750.jpg',
      'https://www.mexicodesconocido.com.mx/wp-content/uploads/2019/03/taco_al_pastor_historia_el_mejor_platillo_comida-768x512.jpg',
    ],
  },
  {
    menuResponse:
      'Chilaquiles estilo La Güerita. TOTOPOS BAÑADOS CON LOS FRIJOLES DE LA ABUELA, CARNE AL PASTOR Y QUESO GRATINADO CON CEBOLLA, CREMA AGRIA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'Chilaquiles estilo La Güerita',
    nutritional_score: 4,
    approximate_calories: 750,
    nutritional_summary: 'High in fats and carbohydrates, moderate protein.',
    is_vegetarian: false,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'medium',
    cholesterol: 'medium',
    sodium: 'high',
    added_free_sugars: 'low',
    carbohydrates: 'high',
    fiber: 'medium',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.tripsavvy.com/thmb/vY9kLj21bCf2ffoy-Kb39ime9Ng=/4032x3024/filters:fill(auto,1)/breakfast-737876157-5b609960c9e77c002512e6be.jpg',
      'https://images.squarespace-cdn.com/content/v1/5e3b43e98166335a98b875b8/1629956253579-P31HHA1X71Q5UJZS9YWU/ChilaquilesVerdes.jpeg',
      'https://www.acouplefortheroad.com/wp-content/uploads/2020/06/Depositphotos_209953730_l-2015.jpg',
    ],
  },
  {
    menuResponse:
      'Tacos de Berenjena al Pastor. LA OPCIÓN VEGANA CON NUESTRO DELICIOSO ALIÑO DE PASTOR SERVIDA EN TORTILLA DE MAÍZ ACOMPAÑADO DE CEBOLLA, CILANTRO Y PIÑA.',
    menuSearchQuery: 'Tacos de Berenjena al Pastor',
    nutritional_score: 7,
    approximate_calories: 350,
    nutritional_summary: 'Low in fats, moderate carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: true,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: 'low',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://grillinwithdad.com/wp-content/uploads/2019/09/al-pastor-taco.jpeg',
      'https://www.jocooks.com/wp-content/uploads/2022/04/tacos-al-pastor-feature-1.jpg',
      'https://www.mdzol.com/u/fotografias/m/2023/4/8/f768x1-1392215_1392342_15.jpg',
    ],
  },
  {
    menuResponse: 'Esquites de maíz dulce. GRANO DE MAÍZ CON MANTEQUILLA, MAYONESA, CHIPOTLE, QUESO FRESCO Y TOTOPOS.',
    menuSearchQuery: 'Esquites de maíz dulce',
    nutritional_score: 5,
    approximate_calories: 400,
    nutritional_summary: 'Moderate in fats and carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'medium',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: null,
    oxalates: null,
    potassium: 'medium',
    calcium: 'medium',
    iron: 'low',
    folate: 'low',
    imageUrls: [
      'https://www.lacostena.com.mx/media/thumbnail/uploads/Recipes/botana/esquites.jpg.1920x800_q85_center.jpg',
      'https://www.mylatinatable.com/wp-content/uploads/2019/07/Esquites-1.jpg',
      'https://mmmole.com/wp-content/uploads/2021/06/esquites-19-1030x682.jpg',
    ],
  },
  {
    menuResponse:
      'Frijoles refritos con totopos. ALUBIAS NEGRAS MEXICANAS TRITURADAS ESPOLVOREADAS DE QUESO FRESCO. ACOMPAÑADO DE TOTOPOS.',
    menuSearchQuery: 'Frijoles refritos con totopos',
    nutritional_score: 6,
    approximate_calories: 450,
    nutritional_summary: 'Moderate in protein and carbohydrates, low fats.',
    is_vegetarian: true,
    is_vegan: false,
    is_glutenFree: false,
    is_dairyFree: false,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'high',
    protein: 'medium',
    purines: 'medium',
    oxalates: null,
    potassium: 'high',
    calcium: 'medium',
    iron: 'medium',
    folate: 'medium',
    imageUrls: [
      'https://i.pinimg.com/originals/48/73/a8/4873a88ab43f278a22ddaed8994e1955.jpg',
      'https://www.senorcactus.com.mx/wp-content/uploads/2022/09/FRIJOLES-REFRITOS-CON-TOTOPOS_01.jpg',
      'https://thumbs.dreamstime.com/b/frijol-frito-mexicano-con-queso-y-totopos-frijoles-fritos-tradicionales-mexicanos-238837731.jpg',
    ],
  },
  {
    menuResponse:
      'Pico de gallo con totopos. MEZCLA DE TOMATE, CEBOLLA, AGUACATE Y CILANTRO, CON NUESTRO ALIÑO ESPECIAL. ACOMPAÑADO DE TOTOPOS.',
    menuSearchQuery: 'Pico de gallo con totopos',
    nutritional_score: 7,
    approximate_calories: 300,
    nutritional_summary: 'Low in fats, moderate carbohydrates, low protein.',
    is_vegetarian: true,
    is_vegan: true,
    is_glutenFree: true,
    is_dairyFree: true,
    trans_fat: 'low',
    cholesterol: 'low',
    sodium: 'medium',
    added_free_sugars: 'low',
    carbohydrates: 'medium',
    fiber: 'medium',
    protein: 'low',
    purines: 'low',
    oxalates: null,
    potassium: 'medium',
    calcium: 'low',
    iron: 'low',
    folate: 'medium',
    imageUrls: [],
  },
];

function HomePage() {
  // State management
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [stream, setStream] = useState(null);
  const [backendAuth, setBackendAuth] = useState({ isAuthenticated: false, user: null, loading: true });
  const [userPlan, setUserPlan] = useState('free');
  const [isStreaming, setIsStreaming] = useState(false);
  const [streamingStatus, setStreamingStatus] = useState('');
  const [streamingProgress, setStreamingProgress] = useState(0);
  const [sequenceCompleted, setSequenceCompleted] = useState(false);
  const [showScrollHint, setShowScrollHint] = useState(false);
  const [selectedFoodItem, setSelectedFoodItem] = useState(null);
  const [showFoodModal, setShowFoodModal] = useState(false);
  const [showStickyFilters, setShowStickyFilters] = useState(false);

  // Demo mode state
  const [isDemoMode, setIsDemoMode] = useState(false);
  const [demoTimeout, setDemoTimeout] = useState(null);

  // Loading placeholder state for menu items
  const [showLoadingPlaceholder, setShowLoadingPlaceholder] = useState(false);

  // Backend completion state
  const [backendCompleted, setBackendCompleted] = useState(false);
  const [backendCompletionData, setBackendCompletionData] = useState(null);

  // Sorting and filtering state
  const [sortBy, setSortBy] = useState('menu_order');
  const [filters, setFilters] = useState({
    vegetarian: false,
    vegan: false,
    glutenFree: false,
    dairyFree: false,
  });
  const [allergenFilters, setAllergenFilters] = useState({
    cereals_containing_gluten: [],
    crustaceans: [],
    eggs: [],
    fish: [],
    peanuts: [],
    soybeans: [],
    milk: [],
    nuts: [],
    celery: [],
    mustard: [],
    sesame_seeds: [],
    sulphur_dioxide_and_sulphites: [],
    lupin: [],
    molluscs: [],
  });

  // Refs
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const menuItemsRef = useRef(null);
  const filterControlsRef = useRef(null);
  const responseSectionRef = useRef(null);

  // Check authentication status from backend
  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch('/auth/status', {
          credentials: 'include',
        });
        if (response.ok) {
          const authData = await response.json();
          setBackendAuth({
            isAuthenticated: authData.isAuthenticated,
            user: authData.user,
            loading: false,
          });
        } else {
          setBackendAuth({ isAuthenticated: false, user: null, loading: false });
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
        setBackendAuth({ isAuthenticated: false, user: null, loading: false });
      }
    };

    checkAuthStatus();
  }, []);

  // Fetch user plan information when authenticated
  useEffect(() => {
    const fetchUserPlan = async () => {
      if (!backendAuth.isAuthenticated) {
        setUserPlan('free');
        return;
      }

      try {
        const response = await fetch('/api/pricing/user', {
          credentials: 'include',
        });

        if (response.ok) {
          const pricingData = await response.json();
          setUserPlan(pricingData.pricing_plan || 'free');
        } else {
          console.error('Failed to fetch user pricing:', response.statusText);
          setUserPlan('free');
        }
      } catch (error) {
        console.error('Error fetching user pricing:', error);
        setUserPlan('free');
      }
    };

    fetchUserPlan();
  }, [backendAuth.isAuthenticated]);

  // Set default demo image for logged-out users
  useEffect(() => {
    if (!backendAuth.loading && !selectedImage) {
      // Set the demo image
      setPreviewUrl('/mejicana.jpeg');
      setIsDemoMode(!backendAuth.isAuthenticated); // Only set demo mode for logged-out users
    }
  }, [backendAuth.loading, backendAuth.isAuthenticated, selectedImage]);

  // Use backend authentication state
  const isAuthenticated = backendAuth.isAuthenticated;
  const isLoading = backendAuth.loading;
  const currentUser = backendAuth.user;

  // Authentication handlers - redirect to backend routes
  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleLogout = () => {
    window.location.href = '/logout';
  };

  // Demo simulation function
  const startDemoSimulation = () => {
    setLoading(true);
    setResponse([]);
    setIsStreaming(true);
    setSequenceCompleted(false);
    setStreamingProgress(0);
    setStreamingStatus('Preparing image...');
    setShowLoadingPlaceholder(true); // Show loading placeholder immediately
    setBackendCompleted(false);
    setBackendCompletionData(null);

    // Create demo data - only add isDemoLocked for logged-out users
    const demoItems = DEMO_MENU_ITEMS.map((item, index) => ({
      ...item,
      // Only lock items for logged-out users (demo mode)
      ...(!backendAuth.isAuthenticated && { isDemoLocked: index >= 2 }),
    }));

    // Simulate the processing stages
    const demoStages = [
      { progress: 10, message: 'Extracting text from image...', delay: 1000 },
      { progress: 20, message: 'Detecting menu language...', delay: 1500 },
      { progress: 25, message: 'Analyzing menu items...', delay: 2000 },
      { progress: 35, message: 'Processing menu data...', delay: 1500 },
      { progress: 70, message: 'Found 18 menu items, loading images...', delay: 2000, showItems: true },
      { progress: 90, message: 'Finalizing results...', delay: 1000 },
      { progress: 100, message: 'All menu items processed successfully!', delay: 500, complete: true },
    ];

    let currentStage = 0;

    const processNextStage = () => {
      if (currentStage >= demoStages.length) return;

      const stage = demoStages[currentStage];
      setStreamingProgress(stage.progress);
      setStreamingStatus(stage.message);

      if (stage.showItems) {
        // Show limited demo items and hide loading placeholder
        setResponse(demoItems);
        setShowLoadingPlaceholder(false);
      }

      if (stage.complete) {
        // Simulate backend completion for demo
        setBackendCompleted(true);
        setBackendCompletionData({
          status: 'complete',
          message: 'All menu items processed successfully!',
          menuItems: demoItems,
        });

        // Don't set isStreaming(false) here - let ProcessingModal finish its sequence
        setLoading(false);
        setShowScrollHint(true);
        setTimeout(() => setShowScrollHint(false), 5000);

        // Demo results now stay visible permanently - no auto-cleanup
      } else {
        currentStage++;
        setTimeout(processNextStage, stage.delay);
      }
    };

    processNextStage();
  };

  // Clear demo timeout when component unmounts or user logs in
  useEffect(() => {
    return () => {
      if (demoTimeout) {
        clearTimeout(demoTimeout);
      }
    };
  }, [demoTimeout]);

  // Filter and sorting functions
  const processMenuItems = items => {
    if (!Array.isArray(items)) return [];

    let filteredItems = [...items];

    // Add loading placeholder if needed
    if (showLoadingPlaceholder) {
      const loadingItem = {
        loading: true,
        menuResponse: '🍽️ Loading menu items...',
        imageUrls: [],
        nutritional_score: null,
        approximate_calories: null,
        is_vegetarian: null,
        is_vegan: null,
        is_glutenFree: null,
        is_dairyFree: null,
      };

      // If we have no real items yet (initial loading), show multiple loading placeholders
      if (filteredItems.length === 0) {
        filteredItems = Array(1)
          .fill(null)
          .map((_, index) => ({
            ...loadingItem,
          }));
      } else {
        // If we have some items already, just add one more loading placeholder
        filteredItems = [...filteredItems, loadingItem];
      }
    }

    // Apply dietary filters - using the correct property names from backend
    if (filters.vegetarian || filters.vegan || filters.glutenFree || filters.dairyFree) {
      filteredItems = filteredItems.filter(item => {
        // Skip filtering for loading items
        if (item.loading) return true;

        return (
          (!filters.vegetarian || item.is_vegetarian === true) &&
          (!filters.vegan || item.is_vegan === true) &&
          (!filters.glutenFree || item.is_glutenFree === true) &&
          (!filters.dairyFree || item.is_dairyFree === true)
        );
      });
    }

    // Apply allergen filters - using the correct property names from backend
    const activeAllergenFilters = Object.entries(allergenFilters).filter(([_, statuses]) => statuses.length > 0);
    if (activeAllergenFilters.length > 0) {
      filteredItems = filteredItems.filter(item => {
        // Skip filtering for loading items
        if (item.loading) return true;

        return activeAllergenFilters.every(([allergenKey, selectedStatuses]) => {
          const itemAllergenValue = item?.[allergenKey];

          // If no allergen data is available, include the item
          if (!itemAllergenValue) {
            return true;
          }

          // If any selected allergen filter has "high" risk, filter OUT this item
          if (selectedStatuses.includes('high') && itemAllergenValue === 'high') {
            return false; // Filter out items with high risk for selected allergens
          }

          // For other statuses (low, medium), include the item
          return true;
        });
      });
    }

    // Apply sorting - keep loading item at the end
    const loadingItems = filteredItems.filter(item => item.loading);
    const regularItems = filteredItems.filter(item => !item.loading);

    regularItems.sort((a, b) => {
      switch (sortBy) {
        case 'nutri_score':
          return (b.nutritional_score || 0) - (a.nutritional_score || 0);
        case 'calories_low':
          return (a.approximate_calories || 0) - (b.approximate_calories || 0);
        case 'calories_high':
          return (b.approximate_calories || 0) - (a.approximate_calories || 0);
        case 'price_low':
          return (a.price || 0) - (b.price || 0);
        case 'price_high':
          return (b.price || 0) - (a.price || 0);
        case 'name':
          const nameA = typeof a === 'string' ? a : a.menuResponse || '';
          const nameB = typeof b === 'string' ? b : b.menuResponse || '';
          return nameA.localeCompare(nameB);
        default:
          return 0;
      }
    });

    // Return regular items first, then loading items
    return [...regularItems, ...loadingItems];
  };

  const toggleNutrientFilter = (allergenKey, status) => {
    setAllergenFilters(prev => ({
      ...prev,
      [allergenKey]: prev[allergenKey].includes(status)
        ? prev[allergenKey].filter(s => s !== status)
        : [...prev[allergenKey], status],
    }));
  };

  const clearAllFilters = () => {
    setFilters({
      vegetarian: false,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
    });
    setAllergenFilters({
      cereals_containing_gluten: [],
      crustaceans: [],
      eggs: [],
      fish: [],
      peanuts: [],
      soybeans: [],
      milk: [],
      nuts: [],
      celery: [],
      mustard: [],
      sesame_seeds: [],
      sulphur_dioxide_and_sulphites: [],
      lupin: [],
      molluscs: [],
    });
  };

  // Camera functions
  const startCamera = async () => {
    console.log('Starting camera...');
    try {
      let mediaStream;

      // Enhanced camera constraints with advanced features
      const advancedConstraints = {
        video: {
          facingMode: 'environment',
          width: { ideal: 1920, min: 1280 },
          height: { ideal: 1080, min: 720 },
          frameRate: { ideal: 30, min: 15 },
          // Advanced features that may be available on mobile browsers
          focusMode: 'continuous',
          autoGainControl: true,
          noiseSuppression: true,
          torch: false, // Start with torch off
        },
      };

      const basicConstraints = {
        video: {
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      };

      try {
        // Try advanced constraints first
        console.log('Trying advanced camera constraints...');
        mediaStream = await navigator.mediaDevices.getUserMedia(advancedConstraints);
      } catch (advancedError) {
        console.log('Advanced constraints failed, trying basic rear camera...', advancedError);
        try {
          // Fallback to basic rear camera
          mediaStream = await navigator.mediaDevices.getUserMedia(basicConstraints);
        } catch (rearError) {
          console.log('Rear camera not available, trying default camera...');
          // Final fallback to any available camera
          mediaStream = await navigator.mediaDevices.getUserMedia({
            video: true,
          });
        }
      }

      console.log('Media stream obtained:', mediaStream);

      // Log camera capabilities for debugging
      const videoTracks = mediaStream.getVideoTracks();
      if (videoTracks.length > 0) {
        const capabilities = videoTracks[0].getCapabilities();
        const settings = videoTracks[0].getSettings();
        console.log('Camera capabilities:', capabilities);
        console.log('Current camera settings:', settings);
      }

      setStream(mediaStream);
      setShowCamera(true);

      // Wait for video element to be available and set the stream
      setTimeout(() => {
        if (videoRef.current) {
          console.log('Setting video source...');
          videoRef.current.srcObject = mediaStream;
          videoRef.current.onloadedmetadata = () => {
            console.log('Video metadata loaded, playing...');
            videoRef.current.play().catch(e => console.error('Error playing video:', e));
          };
        } else {
          console.error('Video ref not available');
        }
      }, 100);
    } catch (error) {
      console.error('Error accessing camera:', error);
      alert(`Unable to access camera: ${error.message}. Please try uploading from gallery instead.`);
    }
  };

  const captureImage = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(blob => {
      setSelectedImage(blob);
      setPreviewUrl(URL.createObjectURL(blob));
      setIsDemoMode(false); // Exit demo mode when user captures their own image
      stopCamera();
    });
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
    setShowCamera(false);
  };

  const handleUploadFromGallery = () => {
    fileInputRef.current?.click();
  };

  const handleClearImage = () => {
    setSelectedImage(null);
    setPreviewUrl('');
    setResponse(null);
    setIsDemoMode(false);
    setShowLoadingPlaceholder(false);
    setBackendCompleted(false);
    setBackendCompletionData(null);

    // Clear any demo timeout
    if (demoTimeout) {
      clearTimeout(demoTimeout);
      setDemoTimeout(null);
    }
  };

  // Image upload and processing
  const handleImageSelect = event => {
    const file = event.target.files[0];
    if (file) {
      // Check for HEIC/HEIF files immediately
      const isHEIC =
        file.type.toLowerCase().includes('heic') ||
        file.type.toLowerCase().includes('heif') ||
        file.name.toLowerCase().endsWith('.heic') ||
        file.name.toLowerCase().endsWith('.heif');

      if (isHEIC) {
        setResponse({
          error: 'HEIC/Live Photo Format Not Supported',
          success: false,
          message:
            'We cannot process HEIC/HEIF images (Live Photos). Please convert your image to JPG or PNG format before uploading, or take a regular photo instead of a Live Photo.',
        });
        // Clear the file input
        event.target.value = '';
        scrollToError();
        return;
      }

      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      setIsDemoMode(false); // Exit demo mode when user selects their own image
      // Clear any previous errors
      setResponse(null);
    }
  };

  const handleConvertStreaming = async () => {
    if (!selectedImage && !previewUrl) return;

    // Only run demo simulation for logged-out users (isDemoMode)
    // Logged-in users should get normal processing even with the demo image
    if (isDemoMode && !backendAuth.isAuthenticated) {
      startDemoSimulation();
      return;
    }

    // If logged-in user is using the demo image, show full demo data without locks
    if (previewUrl === '/mejicana.jpeg' && backendAuth.isAuthenticated) {
      // Show the full demo data without any locks for logged-in users
      setLoading(true);
      setResponse([]);
      setIsStreaming(true);
      setSequenceCompleted(false);
      setStreamingProgress(0);
      setStreamingStatus('Preparing image...');
      setShowLoadingPlaceholder(true);
      setBackendCompleted(false);
      setBackendCompletionData(null);

      // Use full demo data without any locks
      const fullDemoItems = DEMO_MENU_ITEMS.map(item => ({ ...item }));

      // Simulate quick processing for logged-in users with demo image
      const demoStages = [
        { progress: 20, message: 'Processing demo menu...', delay: 500 },
        { progress: 60, message: 'Loading all menu items...', delay: 800, showItems: true },
        { progress: 100, message: 'All menu items loaded successfully!', delay: 500, complete: true },
      ];

      let currentStage = 0;
      const processNextStage = () => {
        if (currentStage >= demoStages.length) return;

        const stage = demoStages[currentStage];
        setStreamingProgress(stage.progress);
        setStreamingStatus(stage.message);

        if (stage.showItems) {
          setResponse(fullDemoItems);
          setShowLoadingPlaceholder(false);
        }

        if (stage.complete) {
          setBackendCompleted(true);
          setBackendCompletionData({
            status: 'complete',
            message: 'All menu items loaded successfully!',
            menuItems: fullDemoItems,
          });
          setLoading(false);
          setShowScrollHint(true);
          setTimeout(() => setShowScrollHint(false), 5000);
        } else {
          currentStage++;
          setTimeout(processNextStage, stage.delay);
        }
      };

      processNextStage();
      return;
    }

    // Regular authenticated user flow with their own uploaded image
    setLoading(true);
    setResponse([]); // Set empty array to show filters/count section
    setIsStreaming(true);
    setSequenceCompleted(false);
    setStreamingProgress(0);
    setStreamingStatus('Preparing image...');
    setShowLoadingPlaceholder(true); // Show loading placeholder until first menu items arrive
    setBackendCompleted(false);
    setBackendCompletionData(null);

    const formData = new FormData();
    formData.append('image', selectedImage);

    try {
      // Step 1: Upload image and get session ID
      const uploadRes = await fetch('/start-menu-processing', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });

      if (!uploadRes.ok) {
        const errorData = await uploadRes.json();
        console.log('errorData', errorData);
        throw new Error(errorData.message || 'Failed to start processing');
      }

      const { sessionId } = await uploadRes.json();

      // Step 2: Connect to SSE stream for updates
      const eventSource = new EventSource(`/menu-processing-stream/${sessionId}`, {
        withCredentials: true,
      });

      eventSource.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          console.log('Streaming event:', data);

          switch (data.type) {
            case 'status':
              setStreamingStatus(data.data.message);
              setStreamingProgress(data.data.progress);

              // Hide loading placeholder when first valid menu items arrive
              if (data.data.menuItems && Array.isArray(data.data.menuItems) && data.data.menuItems.length > 0) {
                setResponse(data.data.menuItems);
                setShowLoadingPlaceholder(false); // Hide loading placeholder when real items arrive
              }

              // Check if processing is complete
              if (data.data.status === 'complete') {
                // Backend completed - save completion data but keep modal visible
                setBackendCompleted(true);
                setBackendCompletionData({
                  status: 'complete',
                  message: 'All menu items processed successfully!',
                  menuItems: data.data.menuItems,
                });

                // Always hide loading placeholder when backend completes
                setShowLoadingPlaceholder(false);

                // If ProcessingModal sequence has already completed, finish immediately
                if (sequenceCompleted) {
                  setIsStreaming(false);
                  setLoading(false);
                  setShowScrollHint(true);
                  setTimeout(() => setShowScrollHint(false), 5000);
                  setResponse(data.data.menuItems);
                } else {
                  // Modal still running, update response
                  if (data.data.menuItems && Array.isArray(data.data.menuItems)) {
                    setResponse(data.data.menuItems);
                  }
                }

                eventSource.close();
              } else if (data.data.status === 'error') {
                setShowLoadingPlaceholder(false);
                throw new Error(data.data.message || 'Processing failed');
              }
              break;

            case 'complete':
              // Backend completed - save completion data but keep modal visible
              setBackendCompleted(true);
              setBackendCompletionData({
                status: 'complete',
                message: 'All menu items processed successfully!',
                menuItems: response, // Use current response if no menuItems in the event
              });
              setStreamingStatus('All menu items processed successfully!');
              setStreamingProgress(100);

              // Always hide loading placeholder when backend completes
              setShowLoadingPlaceholder(false);

              // If ProcessingModal sequence has already completed, finish immediately
              if (sequenceCompleted) {
                setIsStreaming(false);
                setLoading(false);
                setShowScrollHint(true);
                setTimeout(() => setShowScrollHint(false), 5000);
              }

              eventSource.close();
              break;

            case 'error':
              setShowLoadingPlaceholder(false);
              throw new Error(data.data.message || 'Streaming error occurred');
          }
        } catch (parseError) {
          console.error('Error parsing streaming event:', parseError);
          setShowLoadingPlaceholder(false);
          setResponse({
            error: parseError.message || 'Failed to parse server response',
            success: false,
            message: parseError.message || 'An unexpected error occurred during processing.',
          });
          setIsStreaming(false);
          setLoading(false);
          eventSource.close();
          scrollToError();
        }
      };

      eventSource.onerror = error => {
        console.error('EventSource error:', error);
        setStreamingStatus('Connection error occurred');
        setShowLoadingPlaceholder(false);
        setResponse({
          error: 'Connection error',
          success: false,
          message: 'Lost connection to server. Please try again.',
        });
        setIsStreaming(false);
        setLoading(false);
        eventSource.close();
        scrollToError();
      };
    } catch (error) {
      console.error('Error with streaming conversion:', error);
      setShowLoadingPlaceholder(false);
      setResponse({
        error: error.message || 'Failed to process image',
        success: false,
        message: error.message || 'An unexpected error occurred. Please try again with a different image.',
      });
      setIsStreaming(false);
      setLoading(false);
      scrollToError();
    }
  };

  // Scroll functionality
  useEffect(() => {
    const handleScroll = () => {
      if (showScrollHint) {
        setShowScrollHint(false);
      }

      // Show sticky filters when the filter controls section scrolls past the top
      if (Array.isArray(response) && response.length > 0 && filterControlsRef.current) {
        const filterControlsRect = filterControlsRef.current.getBoundingClientRect();
        const shouldShowSticky = filterControlsRect.bottom <= 0;
        setShowStickyFilters(shouldShowSticky);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showScrollHint, response]);

  const handleScrollHintClick = () => {
    if (filterControlsRef.current) {
      filterControlsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    setShowScrollHint(false);
  };

  // Helper function to scroll to error section
  const scrollToError = () => {
    setTimeout(() => {
      if (responseSectionRef.current) {
        responseSectionRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100); // Short delay to ensure DOM is updated
  };

  // Modal functions
  const openFoodModal = (item, index) => {
    setSelectedFoodItem({ ...item, originalIndex: index });
    setShowFoodModal(true);
  };

  const closeFoodModal = () => {
    setShowFoodModal(false);
    setSelectedFoodItem(null);
  };

  // View switching handler
  const navigate = useNavigate();

  const handleViewChange = view => {
    if (view === 'pricing') {
      navigate('/pricing');
    } else {
      navigate('/');
    }
  };

  // Handle upgrade click - switch to pricing page
  const handleUpgradeClick = () => {
    navigate('/pricing');
  };

  return (
    <div className="App">
      {/* Sticky Filters */}
      {Array.isArray(response) && response.length > 0 && (
        <StickyFilters
          isVisible={showStickyFilters}
          filters={filters}
          setFilters={setFilters}
          nutrientFilters={allergenFilters}
          toggleNutrientFilter={toggleNutrientFilter}
          clearAllFilters={clearAllFilters}
          totalItems={response.filter(item => !item.loading).length}
          filteredItems={processMenuItems(response).filter(item => !item.loading).length}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
      )}

      {/* Header Section */}
      <Header
        isLoading={isLoading}
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLogin={handleLogin}
        onLogout={handleLogout}
        currentView="upload"
        onViewChange={handleViewChange}
      />

      {/* Main Content */}
      <main className="main-content">
        <div className="container">
          {/* Hero Section */}
          <div className="hero-section">
            <h3 className="hero-title">
              Turn a photo of your menu into food images, nutritional information and allergens risk
            </h3>
            <p className="hero-description">
              Get images, nutritional information 📊 and allergens risk ⚠️ directly from the menu
            </p>
          </div>

          {!isAuthenticated ? (
            <div className="auth-prompt">
              <div className="auth-prompt-image">
                {isDemoMode ? (
                  <div style={{ position: 'relative', maxWidth: '400px', margin: '0 auto' }}>
                    <iframe
                      width="100%"
                      height="600"
                      src="https://www.youtube.com/embed/Y-sWjoGnsiM?si=E5vD7sZUIWqiQbsv"
                      title="Menu AI Demo Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      style={{
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        maxWidth: '100%',
                        aspectRatio: '9/16',
                      }}
                    ></iframe>
                  </div>
                ) : (
                  <img
                    src="/menu_to_image_chatGPT.png"
                    alt="Menu to images illustration"
                    className="auth-illustration"
                    style={{ width: '500px', height: 'auto', maxWidth: '100%' }}
                  />
                )}
              </div>

              {isDemoMode ? (
                <>
                  <p>Get your tacos 🌮 and nutritional information 📊</p>
                  <button
                    onClick={() => (window.location.href = '/login')}
                    className={`convert-button ${isDemoMode ? 'demo-pulse-button' : ''}`}
                    style={{ marginBottom: '10px' }}
                  >
                    Try it! (It is free)
                  </button>
                  {/* <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
                      Want to try with your own menu?
                      <button
                        onClick={handleLogin}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#007bff',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          marginLeft: '5px',
                        }}
                      >
                        Login here
                      </button>
                    </p> */}
                </>
              ) : (
                <>
                  <p>Please log in to start converting your menus to images.</p>
                  <button onClick={handleLogin} className="convert-button">
                    Login to Get Started
                  </button>
                </>
              )}
            </div>
          ) : (
            <>
              {/* Upload Section */}
              <UploadSection
                selectedImage={selectedImage}
                previewUrl={previewUrl}
                showCamera={showCamera}
                stream={stream}
                loading={loading}
                isStreaming={isStreaming}
                streamingStatus={streamingStatus}
                streamingProgress={streamingProgress}
                onImageSelect={handleImageSelect}
                onStartCamera={startCamera}
                onCaptureImage={captureImage}
                onStopCamera={stopCamera}
                onUploadFromGallery={handleUploadFromGallery}
                onConvert={handleConvertStreaming}
                onClearImage={handleClearImage}
                videoRef={videoRef}
                canvasRef={canvasRef}
              />
            </>
          )}

          {/* Filter Controls - Show after convert button is clicked */}
          {(response || isStreaming || showLoadingPlaceholder) && (
            <div ref={filterControlsRef}>
              <FilterControls
                sortBy={sortBy}
                setSortBy={setSortBy}
                filters={filters}
                setFilters={setFilters}
                nutrientFilters={allergenFilters}
                toggleNutrientFilter={toggleNutrientFilter}
                clearAllFilters={clearAllFilters}
                userPlan={userPlan}
                onUpgradeClick={handleUpgradeClick}
              />
            </div>
          )}

          {/* Items Count Display */}
          {(Array.isArray(response) && response.length > 0) || showLoadingPlaceholder ? (
            <div className="items-count-section">
              <p className="items-count-text">
                {(() => {
                  // Ensure response is an array before filtering
                  const responseArray = Array.isArray(response) ? response : [];
                  const totalItems = responseArray.filter(item => !item.loading).length;
                  const filteredItems = processMenuItems(responseArray).filter(item => !item.loading).length;

                  // Show loading text if we're in loading state with no real items
                  if (showLoadingPlaceholder && totalItems === 0) {
                    return 'Loading menu items...';
                  }

                  return `${filteredItems} of ${totalItems} items`;
                })()}
              </p>
            </div>
          ) : null}

          {/* Processing Modal - Show for both authenticated and demo users */}
          <ProcessingModal
            isVisible={isStreaming && !sequenceCompleted}
            streamingStatus={streamingStatus}
            streamingProgress={streamingProgress}
            onSequenceComplete={() => {
              setSequenceCompleted(true);

              // Always ensure we have at least an empty response array so the response section shows
              if (!response || (!Array.isArray(response) && !response.error)) {
                setResponse([]);
              }

              // If backend has completed, now finish the streaming process
              if (backendCompleted && backendCompletionData) {
                setIsStreaming(false);
                setLoading(false);
                setShowScrollHint(true);
                setTimeout(() => setShowScrollHint(false), 5000);

                // Ensure we have the final menu items and hide loading placeholder
                if (backendCompletionData.menuItems && Array.isArray(backendCompletionData.menuItems)) {
                  setResponse(backendCompletionData.menuItems);
                }
                setShowLoadingPlaceholder(false); // Always hide loading placeholder when backend completed
              } else {
                // Backend hasn't completed yet, show loading placeholder until it completes
                setShowLoadingPlaceholder(true);
                setIsStreaming(false);
                setLoading(false);
              }

              // Always scroll to menu items/responses when modal completes
              setTimeout(() => {
                if (filterControlsRef.current) {
                  filterControlsRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  });
                }
              }, 100); // Short delay to ensure DOM is updated
            }}
          />

          {response && (
            <div className="response-section" ref={responseSectionRef}>
              {response.error || (!Array.isArray(response) && !response.success) ? (
                <div className="error">
                  <span className="error-icon">❌</span>
                  <div className="error-content">
                    <div className="error-title">{response.error || 'Failed to process menu'}</div>
                    {response.message && <div className="error-message">{response.message}</div>}
                  </div>
                </div>
              ) : (
                <div className="success">
                  {/* Menu Items with Images */}
                  {((Array.isArray(response) && response.length > 0) || showLoadingPlaceholder) && (
                    <div className="menu-items-section">
                      <div className="menu-items-grid" ref={menuItemsRef}>
                        {processMenuItems(response || []).map((item, index) => (
                          <MenuItemCard
                            key={`${item.loading ? 'loading' : 'item'}-${index}`}
                            item={item}
                            index={index}
                            onItemClick={openFoodModal}
                            onUpgradeClick={handleUpgradeClick}
                            userPlan={userPlan}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </main>

      {/* Simple Scroll Hint */}
      {showScrollHint && sequenceCompleted && (
        <div className="simple-scroll-hint" onClick={handleScrollHintClick}>
          <span className="scroll-hint-icon">👇</span>
        </div>
      )}

      {/* Food Detail Modal */}
      <FoodDetailModal
        item={selectedFoodItem}
        isVisible={showFoodModal}
        onClose={closeFoodModal}
        onUpgradeClick={handleUpgradeClick}
        userPlan={userPlan}
      />

      <footer className="footer">
        <p>
          Made with ❤️ by{' '}
          <a href="https://x.com/jordibosch20" target="_blank" rel="noopener noreferrer">
            @jordibosch20
          </a>
        </p>
      </footer>
    </div>
  );
}

export default HomePage;
